export default {"src":"/_next/static/media/KKR.73293bcd.svg","height":18,"width":18};